import { render, staticRenderFns } from "./PriceDetail.vue?vue&type=template&id=405f8bc2&scoped=true"
import script from "./PriceDetail.vue?vue&type=script&lang=js"
export * from "./PriceDetail.vue?vue&type=script&lang=js"
import style0 from "./PriceDetail.vue?vue&type=style&index=0&id=405f8bc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405f8bc2",
  null
  
)

export default component.exports